/* Avenwood 2026 — Theme JS (immer defer, kein Render-Blocking) */
(function () {
  'use strict';

  /* Mobile Nav-Drawer */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) {
      document.body.classList.add('drawer-open');
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('.drawer-overlay')) {
      document.body.classList.remove('drawer-open');
    }
    /* Untermenü im Drawer auf-/zuklappen */
    var expand = e.target.closest('[data-drawer-expand]');
    if (expand) {
      var group = expand.closest('.drawer__group');
      var sub = group && group.querySelector('.drawer__sub');
      var open = expand.getAttribute('aria-expanded') === 'true';
      expand.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (sub) sub.hidden = open;
      if (group) group.classList.toggle('is-open', !open);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.body.classList.remove('drawer-open');
  });

  /* Quantity-Stepper */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var input = btn.closest('.qty').querySelector('input');
    var step = parseInt(btn.dataset.qtyChange, 10);
    var min = parseInt(input.min || '1', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart: Mengen-Änderung automatisch absenden */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches('.cart input[name="updates[]"]')) {
      var form = input.closest('form');
      if (form) form.requestSubmit();
    }
  });

  /* PDP: Galerie-Thumbnails */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.pdp__thumb');
    if (!thumb) return;
    var gallery = thumb.closest('.pdp__gallery');
    var main = gallery.querySelector('.pdp__main-media img');
    var src = thumb.dataset.src;
    var srcset = thumb.dataset.srcset;
    if (src && main) {
      // srcset immer setzen bzw. leeren – sonst gewinnt das alte srcset und src greift nicht
      main.srcset = srcset || '';
      main.removeAttribute('sizes');
      main.src = src;
      gallery.querySelectorAll('.pdp__thumb').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    }
  });

  /* PDP: Varianten-Auswahl → Preis/Verfügbarkeit aktualisieren */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    var variantsEl = document.getElementById('ProductVariants-' + form.dataset.sectionId);
    if (!variantsEl) return;
    var variants = JSON.parse(variantsEl.textContent);

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name^="option"]')) return;
      var selected = [];
      form.querySelectorAll('fieldset').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      if (!match) return;
      form.querySelector('input[name="id"]').value = match.id;

      var priceEl = document.querySelector('[data-pdp-price]');
      if (priceEl) priceEl.textContent = match.price_formatted;
      var compareEl = document.querySelector('[data-pdp-compare]');
      if (compareEl) {
        compareEl.textContent = match.compare_at_price_formatted || '';
        compareEl.hidden = !match.compare_at_price_formatted;
      }
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = match.price_formatted;

      var submit = form.querySelector('[data-add-to-cart]');
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.dataset.labelAdd : submit.dataset.labelSoldOut;
      }
    });
  });

  /* PDP: Sticky-CTA auf Mobile. Submit-Verdrahtung für alle Templates. Die
     Sichtbarkeit steuert bei Standard/Bundle das Wegscrollen des ATC-Buttons;
     der Konfigurator hat eine eigene Logik (sichtbar ab Motiv-Auswahl). */
  var stickyCta = document.querySelector('.sticky-cta');
  if (stickyCta) {
    var stickySubmit = stickyCta.querySelector('[data-sticky-submit]');
    if (stickySubmit) stickySubmit.addEventListener('click', function () {
      var form = document.querySelector('form[data-product-form]') || document.querySelector('form[data-bundle-form]');
      if (form) form.requestSubmit();
    });
    var isConfigurator = !!document.querySelector('[data-cfg-step-motiv]');
    var buyAnchor = document.querySelector('[data-add-to-cart]') || document.querySelector('[data-buy-box]');
    if (!isConfigurator && buyAnchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Nur einblenden, wenn der Button nach OBEN aus dem Bild gescrollt ist
        // (nicht, solange er noch unterhalb des Viewports liegt).
        stickyCta.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(buyAnchor);
    }
  }

  /* Versandhinweis: "morgen" durch den effektiven nächsten Arbeitstag (Mo–Fr)
     in CH-Zeit ersetzen. Freitag/Wochenende → Montag, sonst der reale Wochentag. */
  (function () {
    var nodes = document.querySelectorAll('[data-ship-note]');
    if (!nodes.length) return;
    var chNow;
    try { chNow = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Zurich' })); }
    catch (e) { chNow = new Date(); }
    if (isNaN(chNow.getTime())) chNow = new Date();
    var ship = new Date(chNow);
    ship.setDate(ship.getDate() + 1);
    while (ship.getDay() === 0 || ship.getDay() === 6) ship.setDate(ship.getDate() + 1);
    var weekday;
    try { weekday = new Intl.DateTimeFormat('de-CH', { weekday: 'long' }).format(ship); }
    catch (e) {
      weekday = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'][ship.getDay()];
    }
    nodes.forEach(function (el) {
      var tpl = el.getAttribute('data-ship-tpl');
      var on = el.getAttribute('data-ship-on') || 'am {wd}';
      if (tpl) el.textContent = tpl.replace('%%DAY%%', on.replace('%%WD%%', weekday));
    });
  })();

  /* Konfigurator (variable Hüllen): Typ × Ausführung (Motiv/Porto) × Galerie */
  (function () {
    var form = document.querySelector('form[data-product-form]');
    if (!form || !document.querySelector('[data-cfg-step-motiv]')) return;

    var sectionId = form.dataset.sectionId;
    var cfgEl = document.getElementById('CfgConfig-' + sectionId);
    var variantsEl = document.getElementById('ProductVariants-' + sectionId);
    var mediaEl = document.getElementById('CfgMedia-' + sectionId);
    if (!cfgEl || !variantsEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var variants = JSON.parse(variantsEl.textContent);
    var media = mediaEl ? JSON.parse(mediaEl.textContent) : [];
    var phEl = document.getElementById('CfgPortoPlaceholders-' + sectionId);
    var portoPh = phEl ? JSON.parse(phEl.textContent) : [];
    var htEl = document.getElementById('CfgHuellentyp-' + sectionId);
    var typeDescs = {};
    if (htEl) { try { JSON.parse(htEl.textContent).forEach(function (d) { typeDescs[d.key] = d; }); } catch (e) {} }
    var mdEl = document.getElementById('CfgMotifDesc-' + sectionId);
    var motifDescs = {};
    if (mdEl) { try { JSON.parse(mdEl.textContent).forEach(function (d) { motifDescs[d.key] = d; }); } catch (e) {} }

    var mainImg = document.getElementById('CfgMainImage');
    var uspImg = document.getElementById('CfgUspImage');
    var motifImg = document.getElementById('CfgMotifImage');
    var lifestyleImg = document.getElementById('CfgLifestyleImage');
    var badge = document.querySelector('[data-cfg-badge]');
    var badgeReopen = document.querySelector('[data-cfg-badge-reopen]');
    var badgeClose = document.querySelector('[data-cfg-badge-close]');
    var badgeDismissed = false;
    var motivInput = document.querySelector('[data-cfg-motiv-input]');
    var summary = document.querySelector('[data-cfg-type-summary]');
    var typeList = document.querySelector('[data-cfg-types]');
    var typeThumbs = document.querySelector('[data-cfg-type-thumbs]');
    var motifsWrap = document.querySelector('[data-cfg-motifs]');
    var miniEl = document.querySelector('[data-cfg-mini]');
    var miniImg = miniEl && miniEl.querySelector('[data-cfg-mini-img]');
    var miniName = miniEl && miniEl.querySelector('[data-cfg-mini-name]');
    var stickyCtaEl = document.querySelector('.sticky-cta');
    var atcBtnEl = document.querySelector('[data-add-to-cart]');
    var atcInView = false;
    var cfgStockEl = document.querySelector('[data-cfg-stock]');
    var normalStockText = cfgStockEl ? cfgStockEl.textContent : '';

    /* finish: 'ohne' | 'mit' (Laser-Motiv) | 'porto'; swarovski: Aufpreis-Variante */
    var state = { type: cfg.initialType, finish: 'ohne', motiv: '', porto: '', view: 'product', imgIdx: 0, swarovski: false, swVariant: 0, swPrice: 0, uspSrc: '', uspIdx: -1 };
    var currentCat = '';
    var motifTouched = false;

    function finishValue() {
      if (state.finish === 'porto') return state.porto;
      if (state.finish === 'mit') return cfg.gravurMit;
      return cfg.gravurOhne;
    }
    function matchVariantFinish(type, finishVal) {
      return variants.find(function (v) {
        if (cfg.typePos >= 0 && v.options[cfg.typePos] !== type) return false;
        if (cfg.gravurPos >= 0 && finishVal !== undefined && finishVal !== null) {
          if (v.options[cfg.gravurPos] !== finishVal) return false;
        }
        return true;
      });
    }
    function matchVariant(type) { return matchVariantFinish(type, cfg.gravurPos >= 0 ? finishValue() : null); }

    function currentVariant() {
      if (cfg.typePos >= 0 && !state.type) return null;
      return matchVariant(state.type) ||
             matchVariantFinish(state.type, cfg.gravurOhne) ||
             matchVariantFinish(state.type, cfg.gravurMit) ||
             variants[0];
    }

    /* Galerie-Konvention: Bilder = vom Varianten-Bild bis zum nächsten */
    function imagesForVariant(v) {
      if (!media.length) return [];
      if (cfg.typePos < 0) return media;
      if (!v || !v.media_id) return [media[0]];
      var anchorIds = {};
      variants.forEach(function (x) { if (x.media_id) anchorIds[x.media_id] = true; });
      var startIdx = media.findIndex(function (m) { return m.id === v.media_id; });
      if (startIdx < 0) return [media[0]];
      var endIdx = media.length;
      for (var i = startIdx + 1; i < media.length; i++) {
        if (anchorIds[media[i].id]) { endIdx = i; break; }
      }
      return media.slice(startIdx, endIdx);
    }

    function money(cents) { return 'CHF ' + (cents / 100).toFixed(2); }

    function portoColorLabel() { return (state.porto || '').replace(/^porto\s+/i, '').toLowerCase(); }
    function lookupPortoPh(color, type) {
      if (!color) return null;
      return portoPh.find(function (p) { return p.color === color && p.type === type; }) ||
             portoPh.find(function (p) { return p.color === color && !p.type; }) || null;
    }

    function render() {
      var v = currentVariant();
      var images = imagesForVariant(v);
      /* Porto-Variante ohne eigenes Bild → Farb-Platzhalter (falls hinterlegt) */
      if (state.finish === 'porto' && v && !v.media_id) {
        var ph = lookupPortoPh(portoColorLabel(), state.type);
        if (ph) images = [{ src: ph.src, thumb: ph.thumb, alt: state.porto }];
      }
      if (state.imgIdx >= images.length) state.imgIdx = 0;

      if (typeThumbs) {
        typeThumbs.innerHTML = images.map(function (m, i) {
          return '<button class="pdp__thumb" type="button" data-cfg-view="product" data-cfg-idx="' + i + '" aria-label="' +
            m.alt.replace(/"/g, '&quot;') + '"><img src="' + m.thumb + '" alt="" loading="lazy" width="160" height="124"></button>';
        }).join('');
      }

      var submit = form.querySelector('[data-add-to-cart]');
      var stickySubmit = document.querySelector('[data-sticky-submit]');
      var priceEl = document.querySelector('[data-pdp-price]');
      var pricePrefix = document.querySelector('[data-pdp-price-prefix]');
      var compareEl = document.querySelector('[data-pdp-compare]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stockEl = document.querySelector('[data-cfg-stock]');

      if (!v) {
        if (priceEl) priceEl.textContent = cfg.minPriceFormatted;
        if (pricePrefix) pricePrefix.hidden = false;
        if (compareEl) compareEl.hidden = true;
        if (stickyPrice) stickyPrice.textContent = 'ab ' + cfg.minPriceFormatted;
        if (submit) { submit.disabled = true; submit.textContent = submit.dataset.labelChoose; }
        if (stickySubmit) stickySubmit.textContent = submit ? submit.dataset.labelChoose : '';
        if (stockEl) stockEl.hidden = true;
      } else {
        form.querySelector('input[name="id"]').value = v.id;
        /* Preis = Variantenpreis (+ Swarovski-Aufpreis, falls gewählt) */
        var extra = state.swarovski ? state.swPrice : 0;
        var shownFmt = extra ? money(v.price_cents + extra) : v.price_formatted;
        if (priceEl) priceEl.textContent = shownFmt;
        if (pricePrefix) pricePrefix.hidden = true;
        if (compareEl) {
          if (state.swarovski) { compareEl.hidden = true; }
          else { compareEl.textContent = v.compare_at_price_formatted || ''; compareEl.hidden = !v.compare_at_price_formatted; }
        }
        if (stickyPrice) stickyPrice.textContent = shownFmt;
        if (submit) {
          submit.disabled = !v.available;
          submit.textContent = v.available ? submit.dataset.labelAdd : submit.dataset.labelSoldOut;
        }
        if (stickySubmit) stickySubmit.textContent = v.available ? submit.dataset.labelAdd : submit.dataset.labelSoldOut;
        if (stockEl) {
          stockEl.hidden = !v.available;
          stockEl.textContent = state.swarovski ? cfg.swarovskiDelivery : normalStockText;
        }

        if (summary && state.type) {
          var img = summary.querySelector('[data-cfg-summary-img]');
          if (img && v.thumb) img.src = v.thumb;
          summary.querySelector('[data-cfg-summary-name]').textContent = state.type;
          summary.querySelector('[data-cfg-summary-price]').textContent =
            shownFmt + (!state.swarovski && v.compare_at_price_formatted ? ' statt ' + v.compare_at_price_formatted : '');
        }
      }

      var stickyDetail = document.querySelector('[data-sticky-detail]');
      if (stickyDetail) {
        var detailParts = [];
        if (state.type) detailParts.push(state.type);
        if (state.motiv) detailParts.push(state.motiv);
        else if (state.porto) detailParts.push(state.porto);
        stickyDetail.textContent = detailParts.join(' · ');
      }

      renderView(images);
      updateMiniPreview();
      updateStickyCta();
      updateMotifDesc();
    }

    /* Mobile-Mini-Vorschau: spiegelt die aktuelle Auswahl. Für ein Motiv die
       Gravur-Grafik (zeigt die effektive Positionierung des Motivs auf der Hülle),
       für Porto/ohne das aktuelle Vorschaubild. */
    function updateMiniPreview() {
      if (!miniImg) return;
      var name = state.motiv || state.porto || 'Noch keine Auswahl';
      var src = '';
      if (state.finish === 'mit') {
        var mt = document.querySelector('[data-cfg-motif-thumb]');
        if (mt && mt.getAttribute('src')) src = mt.getAttribute('src');
        else if (motifImg && motifImg.dataset.src) src = motifImg.dataset.src;
      }
      if (!src && mainImg) src = mainImg.getAttribute('src') || '';
      if (src) miniImg.src = src;
      if (miniName) miniName.textContent = name;
    }

    /* Badge "Dein Motiv" + Wieder-öffnen-Icon (i): sichtbar nur bei aktivem
       Laser-Motiv in Produktansicht; per x weggeklickt zeigt es das i-Icon. */
    function syncBadge() {
      var active = state.finish === 'mit' && state.view === 'product';
      if (badge) badge.hidden = !active || badgeDismissed;
      if (badgeReopen) badgeReopen.hidden = !active || !badgeDismissed;
    }

    /* Sticky-ATC (Mobile): sichtbar sobald eine Auswahl getroffen ist UND der
       normale "In den Warenkorb"-Button nicht im Bild ist. So muss man die lange
       Motiv-Liste nicht erst zu Ende scrollen. */
    function updateStickyCta() {
      if (!stickyCtaEl) return;
      stickyCtaEl.classList.toggle('is-visible', motifTouched && !atcInView);
    }

    function renderView(images) {
      images = images || imagesForVariant(currentVariant());
      var isProduct = state.view === 'product';
      var isMotif = state.view === 'motif';
      var isLifestyle = state.view === 'lifestyle';
      var isUsp = state.view === 'usp';

      if (isProduct && images.length && mainImg) {
        var m = images[Math.min(state.imgIdx, images.length - 1)];
        if (mainImg.src !== m.src) { mainImg.src = m.src; mainImg.removeAttribute('srcset'); }
      }
      if (motifImg) {
        motifImg.hidden = !isMotif || !motifImg.dataset.src;
        if (isMotif && motifImg.dataset.src) motifImg.src = motifImg.dataset.src;
      }
      if (lifestyleImg) {
        lifestyleImg.hidden = !isLifestyle || !lifestyleImg.dataset.src;
        if (isLifestyle && lifestyleImg.dataset.src) lifestyleImg.src = lifestyleImg.dataset.src;
      }
      if (uspImg) {
        uspImg.hidden = !isUsp || !state.uspSrc;
        if (isUsp && state.uspSrc && uspImg.getAttribute('src') !== state.uspSrc) uspImg.src = state.uspSrc;
      }
      syncBadge();

      document.querySelectorAll('[data-cfg-view]').forEach(function (b) {
        var vw = b.dataset.cfgView;
        var active = vw === state.view &&
          (vw !== 'product' || +b.dataset.cfgIdx === state.imgIdx) &&
          (vw !== 'usp' || +b.dataset.uspIdx === state.uspIdx);
        b.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    /* Motiv-/Porto-Kacheln nach Kategorie + (Porto) Verfügbarkeit filtern */
    /* Gibt es für den gewählten Hüllentyp überhaupt eine Porto-Farbe an Lager? */
    function portoAvailableForType() {
      if (!state.type || !motifsWrap) return false;
      var tiles = motifsWrap.querySelectorAll('.cfg-motif--porto');
      for (var i = 0; i < tiles.length; i++) {
        var pv = matchVariantFinish(state.type, tiles[i].dataset.portoValue);
        if (pv && pv.stocked) return true;
      }
      return false;
    }

    /* Wallet-Schritt (nur MagSafe) ein-/ausblenden; erscheint nach der Motivwahl */
    function isWalletType() {
      return !!(state.type && cfg.walletType && state.type.toLowerCase().trim() === cfg.walletType.toLowerCase().trim());
    }
    function updateWalletStep() {
      var step = document.querySelector('[data-cfg-step-wallet]');
      if (!step) return;
      var show = motifTouched && cfg.hasWallet && isWalletType();
      step.hidden = !show;
      if (!show) {
        var none = step.querySelector('[data-cfg-wallet][value=""]');
        if (none) none.checked = true;
      }
    }

    /* «Über die Hülle»-Akkordeon je nach Hüllentyp einblenden (Metaobjekt) */
    function updateTypeDesc() {
      var acc = document.querySelector('[data-cfg-typedesc]');
      if (!acc) return;
      var d = state.type ? typeDescs[state.type.toLowerCase().trim()] : null;
      if (d) {
        var t = acc.querySelector('[data-cfg-typedesc-title]');
        var b = acc.querySelector('[data-cfg-typedesc-body]');
        if (t) t.textContent = d.title;
        if (b) b.innerHTML = d.html;
        acc.hidden = false;
      } else {
        acc.hidden = true;
      }
    }

    /* «Über das Motiv»-Akkordeon: optionale Beschreibung des gewählten Motivs */
    function updateMotifDesc() {
      var acc = document.querySelector('[data-cfg-motifdesc]');
      if (!acc) return;
      var d = (state.finish === 'mit' && state.motiv) ? motifDescs[state.motiv.trim()] : null;
      if (d && d.html) {
        var b = acc.querySelector('[data-cfg-motifdesc-body]');
        if (b) b.innerHTML = d.html;
        acc.hidden = false;
      } else {
        acc.hidden = true;
      }
    }

    /* Porto-Reiter nur zeigen, wenn es für den Typ verfügbare Farben gibt */
    function updatePortoChip() {
      var chip = document.querySelector('.cfg-chip--porto');
      if (!chip) return;
      var ok = portoAvailableForType();
      chip.hidden = !ok;
      if (!ok && currentCat === cfg.portoCategory) {
        currentCat = '';
        document.querySelectorAll('.cfg-chip').forEach(function (c) {
          c.setAttribute('aria-pressed', c.dataset.cfgCat === '' ? 'true' : 'false');
        });
      }
    }

    function applyMotifFilter() {
      if (!motifsWrap) return;
      var inPorto = currentCat === cfg.portoCategory;
      motifsWrap.querySelectorAll('.cfg-motif').forEach(function (m) {
        var isPorto = m.dataset.portoValue !== undefined;
        var isNone = !isPorto && !m.dataset.cfgMotif;
        var show;
        if (inPorto) {
          if (isPorto) {
            /* Porto: nur Farben mit echtem Lagerbestand für den gewählten Typ */
            var pv = state.type ? matchVariantFinish(state.type, m.dataset.portoValue) : null;
            show = !!(pv && pv.stocked);
          } else { show = false; }
        } else {
          if (isPorto) { show = false; }
          else if (isNone) { show = true; }
          else { show = currentCat === '' || m.dataset.cfgCat === currentCat; }
        }
        m.hidden = !show;
      });
    }

    /* Galerie-Ansicht wechseln */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cfg-view]');
      if (!btn) return;
      state.view = btn.dataset.cfgView;
      if (btn.dataset.cfgIdx !== undefined) state.imgIdx = +btn.dataset.cfgIdx;
      if (btn.dataset.cfgUsp) { state.uspSrc = btn.dataset.cfgUsp; state.uspIdx = +btn.dataset.uspIdx; }
      renderView();
    });

    /* Schritt 1: Typ wählen → Collapse */
    if (typeList) {
      typeList.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cfg-type-value]');
        if (!input) return;
        state.type = input.value;
        state.view = 'product';
        state.imgIdx = 0;
        /* Motiv-Schritt erst nach Hüllentyp-Wahl zeigen */
        var motivStep = document.querySelector('[data-cfg-step-motiv]');
        if (motivStep) motivStep.hidden = false;
        /* Porto-Farbe zurücksetzen, falls für neuen Typ nicht an Lager */
        if (state.finish === 'porto') {
          var pvv = matchVariantFinish(state.type, state.porto);
          if (!pvv || !pvv.stocked) {
            state.finish = 'ohne'; state.porto = ''; state.motiv = '';
            if (motivInput) motivInput.value = '';
            if (badge) badge.hidden = true;
            if (motifsWrap) motifsWrap.querySelectorAll('.cfg-motif').forEach(function (b) {
              b.setAttribute('aria-pressed', (!b.dataset.cfgMotif && b.dataset.portoValue === undefined) ? 'true' : 'false');
            });
          }
        }
        updateTypeDesc();
        updatePortoChip();
        updateWalletStep();
        applyMotifFilter();
        render();
        if (summary) { summary.hidden = false; typeList.hidden = true; }
      });
      var change = document.querySelector('[data-cfg-type-change]');
      if (change) change.addEventListener('click', function () {
        summary.hidden = true;
        typeList.hidden = false;
      });
    }

    /* Schritt 2: Motiv oder Porto-Farbe wählen */
    if (motifsWrap) {
      Array.from(motifsWrap.children)
        .sort(function (a, b) { return (+a.dataset.sort || 999) - (+b.dataset.sort || 999); })
        .forEach(function (el) { motifsWrap.appendChild(el); });

      motifsWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.cfg-motif');
        if (!btn || btn.hidden) return;
        motifsWrap.querySelectorAll('.cfg-motif').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });

        var isMotif = false;
        if (btn.dataset.portoValue !== undefined) {
          state.finish = 'porto'; state.porto = btn.dataset.portoValue; state.motiv = '';
        } else if (btn.dataset.cfgMotif) {
          state.finish = 'mit'; state.motiv = btn.dataset.cfgMotif; state.porto = ''; isMotif = true;
        } else {
          state.finish = 'ohne'; state.motiv = ''; state.porto = '';
        }
        if (motivInput) motivInput.value = state.motiv;

        /* Swarovski-Aufpreis: nur wenn Flag UND Aufpreis-Variante vorhanden sind
           (sonst als normales Motiv behandeln – kein halber Zustand). */
        state.swarovski = isMotif && btn.dataset.cfgSwarovski === 'true' && !!btn.dataset.swVariant;
        state.swVariant = state.swarovski ? parseInt(btn.dataset.swVariant, 10) : 0;
        state.swPrice = state.swarovski && btn.dataset.swPrice ? parseInt(btn.dataset.swPrice, 10) : 0;

        /* Badge-Inhalt nur für Laser-Motiv füllen; Sichtbarkeit regelt syncBadge() */
        if (badge && isMotif) {
          var bImg = badge.querySelector('[data-cfg-badge-img]');
          if (btn.dataset.thumb) { bImg.src = btn.dataset.thumb; bImg.hidden = false; } else { bImg.hidden = true; }
          badge.querySelector('[data-cfg-badge-name]').textContent = state.motiv;
        }

        /* Motiv-Gross-/Lifestyle-Ansicht nur für Laser-Motiv */
        var motifThumbBtn = document.querySelector('[data-cfg-view="motif"]');
        if (motifThumbBtn) {
          var grafik = btn.dataset.grafik || btn.dataset.thumb || '';
          if (isMotif && grafik) {
            motifThumbBtn.querySelector('[data-cfg-motif-thumb]').src = btn.dataset.grafikThumb || btn.dataset.thumb || grafik;
            motifImg.dataset.src = grafik;
            motifThumbBtn.hidden = false;
          } else { motifThumbBtn.hidden = true; delete motifImg.dataset.src; }
        }
        var lifestyleThumbBtn = document.querySelector('[data-cfg-view="lifestyle"]');
        if (lifestyleThumbBtn) {
          if (isMotif && btn.dataset.lifestyle) {
            lifestyleThumbBtn.querySelector('[data-cfg-lifestyle-thumb]').src = btn.dataset.lifestyleThumb || btn.dataset.lifestyle;
            lifestyleImg.dataset.src = btn.dataset.lifestyle;
            lifestyleThumbBtn.hidden = false;
          } else { lifestyleThumbBtn.hidden = true; delete lifestyleImg.dataset.src; }
        }

        if (state.view !== 'product' && !isMotif) state.view = 'product';

        motifTouched = true;
        var foilStep = document.querySelector('[data-cfg-step-foil]');
        if (foilStep) foilStep.hidden = false;
        updateWalletStep();

        render();
      });
    }

    /* Add-ons (Folie + Wallet) → Cart-AJAX als separate Positionen mit «Für Hülle» */
    form.addEventListener('submit', function (e) {
      var addons = [];
      var foilInput = form.querySelector('[data-cfg-foil]:checked');
      if (foilInput && foilInput.value) addons.push(foilInput.value);
      var walletStep = document.querySelector('[data-cfg-step-wallet]');
      if (walletStep && !walletStep.hidden) {
        var walletInput = form.querySelector('[data-cfg-wallet]:checked');
        if (walletInput && walletInput.value) addons.push(walletInput.value);
      }
      /* Swarovski-Aufpreis als separate Position */
      if (state.swarovski && state.swVariant) addons.push(state.swVariant);
      if (!addons.length) return; /* nichts Zusätzliches → normaler Submit */
      e.preventDefault();

      var caseId = parseInt(form.querySelector('input[name="id"]').value, 10);
      var qty = parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1;
      var caseProps = {};
      if (motivInput && motivInput.value) caseProps['Motiv'] = motivInput.value;
      var target = cfg.productTitle + (state.type ? ' · ' + state.type : '');

      var items = [{ id: caseId, quantity: qty, properties: caseProps }];
      addons.forEach(function (id) {
        items.push({ id: parseInt(id, 10), quantity: 1, properties: { 'Für Hülle': target } });
      });

      fetch(cfg.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        window.location.href = cfg.cartUrl;
      }).catch(function () { form.submit(); });
    });

    /* Kategorie-Filter */
    document.querySelectorAll('.cfg-chip[data-cfg-cat]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        document.querySelectorAll('.cfg-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        currentCat = chip.dataset.cfgCat;
        applyMotifFilter();
      });
    });

    /* Sticky-ATC einblenden, sobald Auswahl getroffen und der normale Button
       nicht (mehr) im Bild ist. rootMargin unten, damit die Übergabe sauber
       ist und der normale Button nicht hinter der Sticky-Leiste verschwindet. */
    if (stickyCtaEl && atcBtnEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        atcInView = entries[0].isIntersecting;
        updateStickyCta();
      }, { rootMargin: '0px 0px -80px 0px' }).observe(atcBtnEl);
    }

    /* Badge "Dein Motiv" weg-/wieder-einblenden (x schliesst, i öffnet erneut) */
    if (badgeClose) badgeClose.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      badgeDismissed = true; syncBadge();
    });
    if (badgeReopen) badgeReopen.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      badgeDismissed = false; syncBadge();
    });

    /* Mobile: kompakte Sticky-Vorschau – erscheint sobald die grosse Galerie
       nach oben weggescrollt ist, und verschwindet ab dem Cross-Sell (Buy-Box
       nicht mehr sichtbar). So sieht man die Auswahl beim Motiv-Durchklicken. */
    if (miniEl && 'IntersectionObserver' in window) {
      var galleryEl = document.querySelector('.pdp__gallery');
      var buyBoxEl = document.querySelector('[data-buy-box]');
      var headerEl = document.querySelector('.header');
      if (headerEl) miniEl.style.top = Math.round(headerEl.getBoundingClientRect().height) + 'px';
      var galleryOff = false, buyBoxIn = true;
      var syncMini = function () { miniEl.classList.toggle('is-visible', galleryOff && buyBoxIn); };
      if (galleryEl) new IntersectionObserver(function (en) {
        var e = en[0]; galleryOff = !e.isIntersecting && e.boundingClientRect.top < 0; syncMini();
      }).observe(galleryEl);
      if (buyBoxEl) new IntersectionObserver(function (en) {
        buyBoxIn = en[0].isIntersecting; syncMini();
      }).observe(buyBoxEl);
      miniEl.addEventListener('click', function () {
        (galleryEl || document.body).scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* Initial */
    updateTypeDesc();
    updatePortoChip();
    updateWalletStep();
    applyMotifFilter();
    render();
    if (state.type) {
      var motivStepInit = document.querySelector('[data-cfg-step-motiv]');
      if (motivStepInit) motivStepInit.hidden = false;
      if (summary && typeList) { summary.hidden = false; typeList.hidden = true; }
    }
  })();

  /* Standard-Produkt: Panzerfolie-Upsell (nur in Hüllen-Collection eingeblendet) */
  (function () {
    var foilWrap = document.querySelector('[data-foil-standalone]');
    if (!foilWrap) return;
    var form = foilWrap.closest('form[data-product-form]');
    if (!form) return;
    var sectionId = form.dataset.sectionId;
    var cfgEl = document.getElementById('StdFoilConfig-' + sectionId);
    var variantsEl = document.getElementById('ProductVariants-' + sectionId);
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

    form.addEventListener('submit', function (e) {
      var foil = form.querySelector('[data-foil-addon]:checked');
      if (!foil || !foil.value) return; /* keine Folie → normaler Submit */
      e.preventDefault();

      var caseId = parseInt(form.querySelector('input[name="id"]').value, 10);
      var qtyEl = form.querySelector('input[name="quantity"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;

      var sel = variants.find(function (v) { return v.id === caseId; });
      var target = cfg.productTitle;
      if (sel && sel.title && sel.title !== 'Default Title') target += ' · ' + sel.title;

      fetch(cfg.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: caseId, quantity: qty },
            { id: parseInt(foil.value, 10), quantity: 1, properties: { 'Für Hülle': target } }
          ]
        })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        window.location.href = cfg.cartUrl;
      }).catch(function () {
        form.submit();
      });
    });
  })();

  /* Bundle / Mengenstaffel: Stufe wählen → Menge + Gesamt aktualisieren */
  document.querySelectorAll('[data-bundle-form]').forEach(function (form) {
    var qtyInput = form.querySelector('[data-bundle-qty]');
    var totalEl = form.querySelector('[data-bundle-total]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyQty = document.querySelector('[data-sticky-qty]');
    var stickyBar = document.querySelector('.sticky-cta');
    function sync() {
      var tier = form.querySelector('[data-bundle-tier]:checked');
      if (!tier) return;
      if (qtyInput) qtyInput.value = tier.value;
      if (totalEl) totalEl.textContent = tier.dataset.totalMoney;
      if (stickyPrice) stickyPrice.textContent = tier.dataset.totalMoney;
      if (stickyQty && stickyBar) stickyQty.textContent = '· ' + tier.value + ' ' + (stickyBar.dataset.pieceLabel || '');
    }
    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-bundle-tier]')) sync();
    });
    sync();
  });

  /* Video-Block: Play → Poster durch iframe/Video ersetzen */
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-video-play]');
    if (!play) return;
    var block = play.closest('.video-block');
    var tpl = block.querySelector('template');
    if (tpl) {
      block.innerHTML = '';
      block.appendChild(tpl.content.cloneNode(true));
    }
  });
})();
